import React from 'react'

const SuccessMessage = ({ success }) => {
  return (
    <>
        {
			success ?
				<div className='success'>
					{ success }
				</div>
			: ''
		}
    </>
  )
}

export default SuccessMessage